import { Pipe, PipeTransform } from '@angular/core';
import { ReportStatus } from '@common/enums';

@Pipe({
  name: 'userStatus',
  pure: true
})
export class UserStatusPipe implements PipeTransform {
  private static readonly iconMap: Record<ReportStatus, string> = {
    [ReportStatus.Issue]: 'fa fa-exclamation-circle',
    [ReportStatus.Success]: 'fa fa-check-circle',
    [ReportStatus.Warning]: 'fa fa-exclamation-triangle',
    [ReportStatus.Disabled]: 'fa fa-circle',
    [ReportStatus.Overdue]: 'fa fa-clock-o',
    [ReportStatus.Unknown]: 'fa fa-question'
  };

  private static readonly typeMap: Record<ReportStatus, string> = {
    [ReportStatus.Issue]: 'danger',
    [ReportStatus.Success]: 'success',
    [ReportStatus.Warning]: 'warning',
    [ReportStatus.Disabled]: 'disabled',
    [ReportStatus.Overdue]: 'yellow',
    [ReportStatus.Unknown]: 'muted'
  };

  transform(data: [ReportStatus, string], param: 'icon' | 'type' = 'icon'): any {
    const [state, reason] = data || [];

    if (!state) return '';

    const normalizedState = this.normalizeState(state, reason);

    switch (param) {
      case 'icon':
        return UserStatusPipe.iconMap[normalizedState] || '';
      case 'type':
        return UserStatusPipe.typeMap[normalizedState] || '';
      default:
        throw new Error(`Caught error manually: Unknown userStatus pipe param: ${param}`);
    }
  }

  private normalizeState(state: ReportStatus, reason?: string): ReportStatus {
    const unknownState = state === ReportStatus.Disabled && reason;

    return unknownState ? ReportStatus.Unknown : state;
  }
}
